// ** React Imports
import React, { useState, useEffect } from 'react'

// ** Antd

// ** MUI Imports
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import Button from '@mui/material/Button'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import { useSnackbar } from 'notistack'

// ** Third Party Imports
import ReCaptchaView from 'src/@core/layouts/components/shared-components/ReCaptchaView'

//  Services
import { useAuth } from '../../@core/context/AuthUserContext'
import { validUserName, checkVerifyAccountData, getMyUserSubData } from '../../@core/data/services/userService'
import isEmpty from 'lodash/isEmpty'
import { useTranslation } from 'next-i18next'
import { useFeedbackData } from 'src/@core/services/firestore/hooks/useFeedbackData'
import { v4 as uuidv4 } from 'uuid'

// ** Utils
import { getObjectValueWithDefaultValue } from '../../@core/utils/utils'

// ** Constants
import { MIN_LENGTH, MAX_LENGTH, FEEDBACK_LIST_TYPE } from '../../constants/Constants'

// Redux
import { connect } from 'react-redux'
import { compose } from 'redux'
import { toggleLayoutLoginModal, toggleLayoutVerifyEmailModal } from 'src/@core/redux/actions'

const CardFeedBack = props => {
  const { t } = useTranslation()

  // ** Constants

  const [email, setEmail] = useState('')

  // ** Name
  const [name, setName] = useState('')
  const [validName, setValidName] = useState(true)
  const [messageName, setMessageName] = useState('')

  const [description, setDescription] = useState('')
  const [validDescription, setValidDescription] = useState(true)
  const [messageDescription, setMessageDescription] = useState('')

  //  ** Others
  const [type, setType] = useState('problems')
  const [captcha, setCaptcha] = useState(null)

  // ** Hook
  const { enqueueSnackbar } = useSnackbar()
  const { loading, authUser, dbUser, verifyUserEmail } = useAuth()
  const feedbackHookData = useFeedbackData()

  useEffect(() => {
    if (!loading && isEmpty(authUser)) {
      props.toggleLayoutLoginModal(true)
      //
    } else {
      props.toggleLayoutLoginModal(false)
    }
    // eslint-disable-next-line
  }, [authUser, loading])

  //  ** Data
  useEffect(() => {
    //
    if (!isEmpty(dbUser)) {
      //  ** Get current info
      const nameData = getObjectValueWithDefaultValue(dbUser, 'name', '')
      const emailData = getObjectValueWithDefaultValue(dbUser, 'email', '')

      //  ** Set data
      setName(nameData)
      setEmail(emailData)
    }
  }, [dbUser])

  const handleChangeName = event => {
    const value = event.target.value
    setName(value)

    //
    const valid = validUserName(value)
    let message = ''
    if (valid === false) {
      const stringName = t('userInfo.name')
      if (isEmpty(value) || value.length <= MIN_LENGTH.NAME) {
        message = `${stringName} ${t('general.contains_at_least_min_characters_prefix')} ${MIN_LENGTH.NAME} ${t(
          'general.contains_at_least_characters_subfix'
        )}`
      } else {
        message = `${stringName} ${t('general.contains_at_least_max_characters_prefix')} ${MAX_LENGTH.NAME} ${t(
          'general.contains_at_least_characters_subfix'
        )}`
      }
    }
    setMessageName(message)
    setValidName(valid)
  }

  const handleChangeType = event => {
    setType(event.target.value)
  }

  const handleChangeDescription = event => {
    const value = event.target.value
    setDescription(value)
    //
    let valid = true
    let message = ''
    if (value.length === 0) {
      valid = false
      message = 'Nội dung mô tả là bắt buộc'
    } else {
      if (value.length > 1000) {
        valid = false
        message = 'Nội dung vượt quá giới hạn cho phép'
      }
    }
    setMessageDescription(message)
    setValidDescription(valid)
  }

  async function resendVerifyEmail() {
    let typeError = 'error'
    let messageError = ''

    const resultVerify = await verifyUserEmail()
    if (resultVerify.error) {
      messageError = 'Đã có lỗi xảy ra. Vui lòng thử lại sau'
    } else {
      typeError = 'success'
      messageError = 'Gửi xác nhận thành công. Vui lòng kiểm tra hộp thư của bạn'
    }

    enqueueSnackbar(messageError, {
      autoHideDuration: 5000,
      variant: typeError,
      anchorOrigin: { vertical: 'top', horizontal: 'right' }
    })
  }

  // eslint-disable-next-line no-unused-vars
  const handleClickSave = async event => {
    if (isEmpty(dbUser)) {
      props.toggleLayoutLoginModal(true)
    } else {
      if (checkVerifyAccountData(dbUser) === false) {
        const typeError = 'warning'
        const messageError = t('notify.you_need_to_verify_your_email_account')
        //
        enqueueSnackbar(messageError, {
          autoHideDuration: 3000,
          variant: typeError,
          anchorOrigin: { vertical: 'top', horizontal: 'right' }
        })
        props.toggleLayoutVerifyEmailModal(true)

        //
        await resendVerifyEmail()
      } else {
        let typeError = 'error'
        let messageError = ''

        // Check captcha
        const validCapcha = !isEmpty(captcha)

        //
        const validInfo = validDescription && validCapcha
        if (validInfo === true && name.length > 0 && email.length > 0 && description.length > 0) {
          //
          const reviewId = uuidv4()
          const strDateTime = String(new Date().getTime())

          const blogInfo = {
            _id: reviewId,
            type: FEEDBACK_LIST_TYPE.SUPPORT,
            description,
            updatedAt: strDateTime,
            updatedUser: getMyUserSubData(dbUser),
            createdUser: getMyUserSubData(dbUser),
            createdAt: strDateTime,
            isDel: false
          }
          //
          const resultUpdated = await feedbackHookData.actions.createNewFeedback(blogInfo._id, blogInfo)
          if (resultUpdated.error) {
            typeError = 'error'
            messageError = 'Gửi phản hồi thất bại. Vui lòng thử lại sau!!!'
          } else {
            typeError = 'success'
            messageError = 'Gửi phản hồi thành công. Chúng tôi sẽ phản hồi sớm!!!'
          }
        } else {
          messageError = t('order.please_input_missing_data')
        }
        if (messageError.length > 0) {
          enqueueSnackbar(messageError, {
            autoHideDuration: 3000,
            variant: typeError,
            anchorOrigin: { vertical: 'top', horizontal: 'right' }
          })
        }
      }
    }
  }

  function onChangeReCaptcha(token) {
    if (!isEmpty(token)) {
      setCaptcha(token)
    }
  }

  return (
    <CardContent>
      <form>
        <Grid container spacing={7}>
          <Grid item xs={12}>
            <TextField
              error={!validName}
              fullWidth
              id='first_name'
              label={t('userInfo.last_name')}
              value={name}
              onChange={handleChangeName}
              helperText={messageName}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type='email'
              label={t('userInfo.email')}
              placeholder='johnDoe@example.com'
              value={email}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <FormLabel sx={{ fontSize: '0.875rem' }}>{t('userInfo.type')}</FormLabel>
              <RadioGroup
                row
                defaultValue='problems'
                aria-label='type'
                name='account-settings-info-radio'
                value={type}
                onChange={handleChangeType}
              >
                <FormControlLabel value='problems' label='Vấn đề khó khăn' control={<Radio />} />
                <FormControlLabel value='features' label='Vấn đề tính năng' control={<Radio />} />
                <FormControlLabel value='others' label='Vấn đề khác' control={<Radio />} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              label={t('userInfo.description')}
              minRows={4}
              placeholder={'Viết mô tả...'}
              value={description}
              error={!validDescription}
              helperText={messageDescription}
              onChange={handleChangeDescription}
            />
          </Grid>

          <Grid item xs={12}>
            <ReCaptchaView receiveToken={onChangeReCaptcha} />
          </Grid>

          <Grid item xs={12}>
            <Button variant='contained' sx={{ marginRight: 3.5 }} onClick={handleClickSave}>
              {'Gửi'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </CardContent>
  )
}

export function mapDispatchToProps(dispatch) {
  return {
    toggleLayoutLoginModal: value => dispatch(toggleLayoutLoginModal(value)),
    toggleLayoutVerifyEmailModal: value => dispatch(toggleLayoutVerifyEmailModal(value))
  }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(React.memo, withConnect)(CardFeedBack)
